// @flow

import React from 'react';
import { connect } from 'react-redux';
import PdbCallToAction from './pdbCallToAction';
import {
  getButtonText,
} from '../../store/componentSettings/selectors/pdbCTASettings';
import {
  getAddComparisonText,
  getRemoveComparisonText,
  canAddModelToCompare,
} from '../../store/compareSettings/selectors';
import { getVbmrConfigLink, getDeliveryTimeText } from '../../store/pdb/selectors';
import { isPdbIdInComparison, toggleActivePdbId } from '../../store/pdbComparison';
// import type { State } from '../../types';

type StateProps = {|
  addComparisonText: string,
  buttonText: string,
  canCompare: boolean,
  configLink: string,
  deliveryTimeText: string,
  inComparison: boolean,
  removeComparisonText: string,
|};

type DispatchProps = {|
  onCompare: Function,
|};

type Props = {|
  ...StateProps,
  ...DispatchProps,
|};

const PdbCTA = ({
  addComparisonText,
  buttonText,
  canCompare,
  configLink,
  deliveryTimeText,
  inComparison,
  onCompare,
  removeComparisonText,
}: Props) => (
  <PdbCallToAction
    addToComparisonText={addComparisonText}
    buttonLink={configLink}
    buttonText={buttonText}
    canCompare={canCompare}
    deliveryTimeText={deliveryTimeText}
    inComparison={inComparison}
    onCompare={onCompare}
    removeFromComparisonText={removeComparisonText}
  />
);

const mapStateToProps = (state): StateProps => ({
  addComparisonText: getAddComparisonText(state),
  buttonText: getButtonText(state),
  canCompare: canAddModelToCompare(state),
  configLink: getVbmrConfigLink(state),
  deliveryTimeText: getDeliveryTimeText(state),
  inComparison: isPdbIdInComparison(state),
  removeComparisonText: getRemoveComparisonText(state),
});

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  onCompare: () => dispatch(toggleActivePdbId()),
});

export default connect<Props, any, StateProps, DispatchProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(PdbCTA);
